import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCrumbPasosV2 from "components/BreadCrumbMex/BreadCrumbPasosV2";
import Page from "components/Page";
import Planes from "components/PlanesProducto/OpcionesCatalogo";
import { ambienteAplicacion } from "constants/urls";
import { useNavbarContext } from "contexts/NavbarContext";
import useCustomToast from "hooks/useCustomToasts";
import React, { createContext, useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { PASOS_BREADCRUMBS } from "utils/constants";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import Loading from "wrappers/Loading";
import { CYBER } from "./constantes/general";
import { URLS_PHP_7 } from "constants/urls_v2";
import { ApiKeyFetch } from "api/fetchers/apiKey";

export const PlanesContext = createContext();

const CyberPlanes = ({ qParams, dataUsuario: { cliCodigoCore }, history }) => {
  useNavbarContext(PRODUCTOS.CYBER);

  const [loading, setLoading] = useState(false);
  const [catalogo, setCatalogo] = useState({});
  const { addWarningToast } = useCustomToast();
  const methods = useForm({ mode: "onChange" });
  const { handleSubmit } = methods;

  const onSubmit = async (value) => {
    setLoading(true);
    const planesAnidados = catalogo?.planes?.map((plan) => {
      return { ...plan, seleccion: plan.nombreOpcion === value.planSeleccionado };
    });
    catalogo.planes = planesAnidados;

    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: CYBER.prodCodigoCore,
      pasoCodigo: "planSelecionado",
      items: {
        idCotizacion: qParams?.idCotizacion || "",
        usuCotiza: { usuCodigo: cliCodigoCore || "" },
        planes: catalogo.planes,
        etiquetas: catalogo?.etiquetas,
      },
    };


    let res;
    res = await ApiKeyFetch.instance().post(URLS_PHP_7.cotizacion.actualizarCotizacion, Data);

    if (res.transaccion) {
      history.push(`${CYBER.urls.resumen}?idCotizacion=${qParams?.idCotizacion}`);
    } else {
      setCatalogo(catalogo);
      try {
        res.errorDescripcion.forEach((msg) =>
          addWarningToast(msg, { autoDismiss: false })
        );
      } catch (e) {
        addWarningToast("Error desconocido", { autoDismiss: false });
      }
    }
    setLoading(false);
  };
  const onSubmitError = () => {};

  const getResumen = async (datosIniciales) => {
    const DataResumen = {
      cotDatos: {
        ambiente: ambienteAplicacion,
        cotCodigo: qParams?.idCotizacion,
      },
    };
    try {
      let resResumen;
      resResumen = await ApiKeyFetch.instance().post(
        URLS_PHP_7.cotizacion.resumenCotizacion,
        DataResumen
      );
      if (resResumen?.transaccion) {
        const preLoad = resResumen?.cotConsulta?.prodDatos[0]?.planes;

        preLoad && setCatalogo({ ...datosIniciales, planes: preLoad });
      }
    } catch (error) {
      setLoading(false);
    }
    setLoading(false);
  };

  const getData = useCallback(
    async (codRetroactividad = 0, llaveSumaAsegurada = 0, preload = true) => {
      if (!qParams?.idCotizacion) {
        history.push("/");
      }

      setLoading(true);

      const Body = {
        datosCotizador: {
          prodCodigo: CYBER.prodCodigoCore,
          catPasoCodigo: "planes",
          idCotizacion: qParams?.idCotizacion,
          llaveSumaAsegurada,
          codRetroactividad,
          usuCotiza: { usuCodigo: cliCodigoCore || "" },
        },
      };
      try {
        const res = await ApiKeyFetch.instance().post(URLS_PHP_7.cotizacion.catalogosCotizador, Body);
        if (res?.transaccion) {
          setCatalogo({ ...res?.catalogo?.planes });
          if (preload) {
            if (res?.catalogo?.consumirResumen === true) {
              return getResumen(res?.catalogo?.planes);
            }
          }
        }
      } catch (error) {
        setLoading(false);
      }
      setLoading(false);
    },
    []
  );

  const handleRegresar = () => {
    history.push(`${CYBER.urls.preguntas}?idCotizacion=${qParams?.idCotizacion}`);
  };

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Loading loading={loading}>
      <div className='cr-content'>
        <Page>
          <BreadCurmb {...PASOS_BREADCRUMBS[PRODUCTOS.CYBER].breadCrumb} />

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.CYBER].breadCrumbPasosCotizacion[3]}
            styleimg='height200px mr-3'
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.CYBER]?.pasosCotizacion}
          />

          {/* <DevTool control={methods.control}/> */}
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit, onSubmitError)}>
              <PlanesContext.Provider value={{ getData, notaPopup: catalogo?.notaPopup }}>
                <Planes
                  identificadorPlan='nombreOpcion'
                  handleRegresar={handleRegresar}
                  catalogo={catalogo || {}}
                  showToolTip={false}></Planes>
              </PlanesContext.Provider>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};

export default CyberPlanes;
